import React from "react";
import "./CustomNoRowsOverlay.css";

const CustomNoRowsOverlay = ({ message }) => {
    return (
        <div className="custom-no-rows-overlay">
            <svg
                className="custom-no-rows-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                fill="none"
            >
                <circle cx="28" cy="28" r="20" stroke="#AD0101" strokeWidth="3" fill="none" />
                <line x1="42" y1="42" x2="56" y2="56" stroke="#AD0101" strokeWidth="3" strokeLinecap="round" />
                <line x1="20" y1="28" x2="36" y2="28" stroke="#AD0101" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
            <p className="custom-no-rows-text">{message || "No users found"}</p>
            {/* <p className="custom-no-rows-subtext">Try adjusting your search or filter criteria</p> */}
        </div>
    );
};

export default CustomNoRowsOverlay;
